import React, { useEffect, useState, Fragment,useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import GateCard from 'components/sales/cardSection/gateCard/gateCard';
import { MrfStatus } from 'components/installation/mrfStatus/mrfStatus';
import ModalPop from 'components/sales/modal/modal';
import FormSectionNew from 'components/sales/formSection/formSectionNew';
import { Button } from 'react-bootstrap';
import Checkbox from 'components/sales/Input/checkbox/checkbox';
import DocumentView from 'components/sales/downloadDocView/documentView';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import Regex from 'services/utils/regex/Regex';
import { ConsolidateReport } from 'components/installation/consolidateReport/consolidateReport';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import useLatLng from 'hooks/uselatlng/uselatlng';
import { Link } from "react-router-dom";
import './carnival.css';
import DistanceCalculator from "../../DistanceCalculator/Calculator";
import {toast} from "react-toastify";
import {BaseUrl} from "../../../contexts/baseUrl/baseUrl";
import FileUpload from "components/sales/fileUpload/fileUpload";
import SiteInfoQuestions from 'components/sales/formSection/siteInfo/siteInfo';

const CarnivalConduct = ({
  getSiteCarnivalChecklist,
  siteData,
  match,
  history,
  documentUploadUrl,
  postReportDetails,
  generateReport,
  getLocationApprovalPending,
  location,
  locationApproval,
  getPocBySiteId,
  pocListBySiteId,
  postSendReportMail,
  getCheckLocation,
  locationCheck,
  userProfile,
  getSiteData,
  calculateDistance,
  engDistanceData,
  siteDetails,
  getDistanceData,
  distanceDetails,
  documentUploadUrlPublic,
  documentUrlDataPublic,
  postCarnivalData,
  getCarnivalCompletedDetails,
  checklistDetails
}) => {
  const islatlng = useLatLng();
  const [modalFlag, setModalFlag] = useState(null);
  const [isModal, setIsModal] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [generateFlag, setGenerateFlag] = useState(false);
  const [mrfReportModal, setMrfReportModal] = useState(false);
  const [generateReportFlag, setGenerateReportFlag] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [flag, setFlag] = useState(false);
  const [poclist, setPocList] = useState([]);
  const [modal, setModal] = useState(false);
  const [showOtherEmail, setShowOtherEmail] = useState(false);
  const [mailList, setMailList] = useState([]);
  const [otherEmail, setOtherEmail] = useState();
  const [rentalInvoice, setRentalInvoice] = useState('');
  const [rentalCheck, setRentalCheck] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [role, setRole] = useState('')
  const { baseUrl } = useContext(BaseUrl);
  const [opened, setIsOpened] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [passCode,setPasscode] = useState(null);
  const [docFileUrl, setDocFileUrl] = useState(null);
  const [formData, setFormData] = useState(null);
  const [isFiled, setIsFiled] = useState(false);
  const [isChecklistFilled, setCheckListDetails] = useState([]);
  const [containerData, setContainerData] = useState(['site-inspection','civil-checklist','hardware-installation','handover-testing']);
  const [scheduledId,setScheduledId] = useState(null);
  const [infraProjectId,setInfraProjectId] = useState(null); 
  const [roles,setRoles] = useState([14,15,56]);
  const [roleId,setRoleId] = useState('');

  useEffect(() => {
    let roles = JSON.parse(localStorage.getItem('roles'))
    setRole(roles[0]?.id)
    setIsOpen(!isOpen);
  }, [])
  console.log(JSON.stringify(siteData));

  useEffect(() => {
    if(siteData?.infraProjectId !== undefined && siteData?.infraProjectId !== null) {
      setInfraProjectId(siteData?.infraProjectId);
    }
    if(siteData?.isCarnivalScheduled !== undefined && siteData?.isCarnivalScheduled !== null) {
      setScheduledId(siteData?.isCarnivalScheduled);
    }
  },[siteData]);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(true);
      (async () => {
        if(localStorage.getItem('roles')){
          const roles = await JSON.parse(localStorage.getItem('roles'))[0].id;
          setRoleId(roles);
        }
       
      })();
      setIsLoading(false);
    }, 1000);
  }, []);

  // useEffect( () => {
  //   (async () => {
  //     await getDistanceData(match.params.id, match.params.gate)
  //   })()
  // }, [match.params.gate])

  // useEffect( () => {
  //   setIsOpen(true)
  //   if(distanceDetails !== undefined && Object.keys(distanceDetails).length > 0){
  //     if(!distanceDetails['total_hours']){
  //       setIsOpen(false);
  //     }
  //   }
  // }, [distanceDetails])

  useEffect(() => {
    if(getCarnivalCompletedDetails) {
      (async () => {
        await getCarnivalCompletedDetails(match.params.id, match.params.stageId);
      })(); 
    }
  },[getCarnivalCompletedDetails]);

  useEffect(() => {
     if(checklistDetails !== undefined && checklistDetails !== null) {
          setCheckListDetails(checklistDetails);
     }
  },[checklistDetails]);

  useEffect(() => {
    (() => {
      if (
        poclist &&
        poclist.length > 0 
      ) {
        setShowOtherEmail(true);
      } else {
        setShowOtherEmail(false);
      }
    })();
  }, [poclist]);

  useEffect(() => {
    if (
      getSiteCarnivalChecklist !== null &&
      match.params.id &&
      getLocationApprovalPending !== null
    )
      (async () => {
        setIsLoading(true);
        await getSiteCarnivalChecklist(match.params.id, match.params.stageId);
        if (match.params.gate === 'site-inspection') {
          await getLocationApprovalPending(
            match.params.id,
            islatlng?.lat,
            islatlng?.lng
          );
        } else {
          await getCheckLocation(match.params.id, islatlng?.lat, islatlng?.lng);
        }
        await getPocBySiteId(match.params.id);
        setIsLoading(false);
      })();
  }, [getSiteCarnivalChecklist]);


  const handleModalHide = () => setModalFlag(null);
  const modalHide = () => setIsModal(null);
  const mrfReportModalHide = () => setMrfReportModal(false);
  const openHideModal = () => setOpenModal(false);
  const emailModalHide = () => setModal(false);
  const checkInventory = (val) => {
    setFlag(val);
    siteData &&
      siteData.gates &&
      siteData.gates.length > 0 &&
      siteData.gates.map((obj) => {
        obj.checklist_data.map((el) => {
          if (el.checklist_id === 8 && (el.completed === 1 || obj.is_material_update === 1)) {
            setModalFlag(false);
          }
          else if (el.checklist_id === 8 && (el.completed === null )) {
            setModalFlag(true);
          }
          
        });
      });
  };

  useEffect(() => {
    if (modalFlag === false && modalFlag !== null) {
      history.push({
        pathname: `/dashboard/material-requisition/${match.params.id}/stage/${match.params.stageId}`,
        state: { view: flag, status: location.state && location.state.status },
      });
    }
  }, [modalFlag]);

  const onClickViewMrf = (val) => {
    checkInventory(val);
  };

  const checklisting = () => {
    setIsDisabled(true);
    if (!location.pathname.includes('handover-testing')) {
      siteData &&
        siteData.gates &&
        siteData.gates.length > 0 &&
        siteData.gates.map((obj) => {
          obj.checklist_data.map((el) => {
            if (
              siteData &&
              siteData.hasOwnProperty('mrf') &&
              siteData.mrf &&
              Object.keys(siteData.mrf).length === 0
            ) {
              setIsDisabled(false);
              setMrfReportModal(true);
            } else if (el.completed === 1 || obj.is_material_update === 1) {
              setIsDisabled(false);
              setIsModal(false);
            } else {
              setIsDisabled(false);
              setIsModal(true);
            }
          });
        });
    } else {
      siteData &&
        siteData.checklist_data &&
        siteData.checklist_data.length > 0 &&
        siteData.checklist_data.map((obj) => {
          if (obj.completed === null) {
            setIsDisabled(false);
            setIsModal(true);
          } else {
            setIsDisabled(false);
            setIsModal(false);
          }
        });
    }
  };

  useEffect(() => {
    (async () => {
      if (isModal === false) {
        const data = {
          site_id: match.params.id,
          stage_id: match.params.stageId,
          passCode: passCode,
          fileAttached: docFileUrl
        };
        setIsLoading(true);
        const res = await generateReport(data);
        setIsLoading(false);
        if (res?.success) {
          setGenerateFlag(true);
          getSiteCarnivalChecklist(match.params.id, match.params.stageId);
        }
      }
    })();
  }, [isModal]);

  useEffect(() => {
    if (
      Object.keys(siteData?.report_data !== undefined && siteData?.report_data)
        .length > 0
    ) {
      setGenerateReportFlag(true);
    } else if (
      Object.keys(siteData?.report_data !== undefined && siteData?.report_data)
        .length === 0
    ) {
      setGenerateReportFlag(false);
    }
  }, [siteData]);

  const hideReport = () => {
    setGenerateFlag(false);
    getSiteCarnivalChecklist(match.params.id, match.params.stageId);
  };

  const sendMail = (val) => {
    if (val) {
      setOpenModal(true);
    }
  };
  useEffect(() => {
    const list =
      poclist && poclist.length > 0 && poclist.map((element) => element['id']);
    setMailList(list);
  }, [poclist]);

  const sendMailPoc = async () => {
    const findIndex =
      mailList &&
      mailList.length > 0 &&
      mailList.findIndex((el) => el === 'Others');
    if (findIndex !== -1) {
      mailList.splice(findIndex, 1);
      mailList.push(otherEmail);
      setMailList([...mailList]);
    }
    const data = {
      stage_id: match.params.stageId,
      id: match.params.id,
      pocs: mailList,
    };
    if (data.pocs.length > 0) {
      setIsLoading(true);
      openHideModal();
      const res = await postSendReportMail(data);
      setIsLoading(false);
      if (res === true) {
        setModal(true);
      }
    }
  };

  useEffect( () => {
    if(engDistanceData !== null && Object.keys(engDistanceData).length > 0){
      toast.success('Distance is successfully fetched');
      setIsOpen(false);
      Object.keys(engDistanceData).forEach(key => {
        delete engDistanceData[key];
      })
    }else if(engDistanceData === null){
      toast.success('Distance is not fetched');
      setIsOpen(true);
    }
  }, [engDistanceData])

  const handleFormVal = (val) => {
    setFormData(val);
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <a className="btn btn-primary" href={`/dashboard/carnival-details/${match.params.id}/stg/${match.params.stageId}/${match.params.leadId}`}>Carnival Details</a>
        <Button onClick={handleSubmit} className="btn btn-primary">
          {localization.submitDtl}
          <img src={Images?.ArrowRight} alt="" />
        </Button>
      </Fragment>
    );
  };

  const handleSubmit = async () => {
     if(formData === null) {
        toast.error('Please fill checklist.');
        return false;
     }
     if(scheduledId === null) {
        toast.info('Carnival not scheduled on this site. Please schedule carnival first.');
        return false;
     }
     if(infraProjectId === null) {
      toast.info('Project id missing.');
      return false;
     }
     //console.log(formData); return false;
     const payload = {
       "carnival_scheduled_id":scheduledId,
       "infra_id":infraProjectId,
       "checklist":formData
     }
     setIsLoading(true);
     const res = await postCarnivalData(payload);
     setIsLoading(false);
     if (res) { 
       setIsModal(true);
     } else {
      toast.error('Something went wrong...');
     }
     setIsLoading(false);
 }
  return (
    <Layout
      title={`Carnival`}
      Buttons={(roles.includes(roleId)) ? headerBtns : null}
      isGoback
      isLoading={isLoading}
      linkFlag={true}
      linkUrl={`/dashboard/site-stage/${match.params.id}/${match.params.leadId}`}
    >
      {role === 9 && isOpen && opened ?
          <div className="popup-box">
            <div className="box">
              {siteDetails?.lead_id !== undefined &&
                  <Link
                      to={`${baseUrl}/site-stage/${match.params.id}/${siteDetails?.lead_id}`}
                      className="btn btn-primary mb-4"
                      style={{
                        'cursor': 'pointer',
                        'border': '0px',
                        'box-shadow': 'none !important',
                        'position': 'relative',
                        'top': '-17px',
                        'float':'right'
                      }}
                  >
                    x
                  </Link>
              }
              <DistanceCalculator
                  siteData={siteDetails}
                  getSiteData={getSiteData}
                  calculateDistance={calculateDistance}
                  siteId={match.params.id}
                  moduleType={match.params.gate}
                  to={`${baseUrl}/site-stage/${match.params.id}/${siteDetails?.lead_id}`}
              />
            </div>
          </div> :
          <SiteInfoQuestions
            className={isFiled && 'requiredFileds'}
            data={siteData}
            handleValue={handleFormVal}
            documentUploadUrl={documentUploadUrl}
            match={match}
            location={location}
          />

     } 
     <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{'Carnival saved.'}</h5>
          <Link
            to={`${baseUrl}/carnival-details/${match.params.id}/stg/${match.params.stageId}/${match.params.leadId}`}
            className="btn btn-primary mb-4"
          >
            {`Go to details.`}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};
export default CarnivalConduct;
